[
  {
    "controlkey": "pt01_FacialProbingDepthD",
    "controlvalue": 1
  },
  {
    "controlkey": "pt01_FacialProbingDepthC",
    "controlvalue": 2
  },
  {
    "controlkey": "pt01_FacialProbingDepthM",
    "controlvalue": 3
  },
  {
    "controlkey": "pt02_FacialProbingDepthD",
    "controlvalue": 4
  },
  {
    "controlkey": "pt02_FacialProbingDepthC",
    "controlvalue": 5
  },
  {
    "controlkey": "pt02_FacialProbingDepthM",
    "controlvalue": 6
  },
  {
    "controlkey": "pt03_FacialProbingDepthD",
    "controlvalue": 7
  },
  {
    "controlkey": "pt03_FacialProbingDepthC",
    "controlvalue": 8
  },
  {
    "controlkey": "pt03_FacialProbingDepthM",
    "controlvalue": 9
  },
  {
    "controlkey": "pt04_FacialProbingDepthD",
    "controlvalue": 10
  },
  {
    "controlkey": "pt04_FacialProbingDepthC",
    "controlvalue": 11
  },
  {
    "controlkey": "pt04_FacialProbingDepthM",
    "controlvalue": 12
  },
  {
    "controlkey": "pt05_FacialProbingDepthD",
    "controlvalue": 13
  },
  {
    "controlkey": "pt05_FacialProbingDepthC",
    "controlvalue": 14
  },
  {
    "controlkey": "pt05_FacialProbingDepthM",
    "controlvalue": 15
  },
  {
    "controlkey": "pt06_FacialProbingDepthD",
    "controlvalue": 16
  },
  {
    "controlkey": "pt06_FacialProbingDepthC",
    "controlvalue": 17
  },
  {
    "controlkey": "pt06_FacialProbingDepthM",
    "controlvalue": 18
  },
  {
    "controlkey": "pt07_FacialProbingDepthD",
    "controlvalue": 19
  },
  {
    "controlkey": "pt07_FacialProbingDepthC",
    "controlvalue": 20
  },
  {
    "controlkey": "pt07_FacialProbingDepthM",
    "controlvalue": 21
  },
  {
    "controlkey": "pt08_FacialProbingDepthD",
    "controlvalue": 22
  },
  {
    "controlkey": "pt08_FacialProbingDepthC",
    "controlvalue": 23
  },
  {
    "controlkey": "pt08_FacialProbingDepthM",
    "controlvalue": 24
  },
  {
    "controlkey": "pt09_FacialProbingDepthM",
    "controlvalue": 25
  },
  {
    "controlkey": "pt09_FacialProbingDepthC",
    "controlvalue": 26
  },
  {
    "controlkey": "pt09_FacialProbingDepthD",
    "controlvalue": 27
  },
  {
    "controlkey": "pt10_FacialProbingDepthM",
    "controlvalue": 28
  },
  {
    "controlkey": "pt10_FacialProbingDepthC",
    "controlvalue": 29
  },
  {
    "controlkey": "pt10_FacialProbingDepthD",
    "controlvalue": 30
  },
  {
    "controlkey": "pt11_FacialProbingDepthM",
    "controlvalue": 31
  },
  {
    "controlkey": "pt11_FacialProbingDepthC",
    "controlvalue": 32
  },
  {
    "controlkey": "pt11_FacialProbingDepthD",
    "controlvalue": 33
  },
  {
    "controlkey": "pt12_FacialProbingDepthM",
    "controlvalue": 34
  },
  {
    "controlkey": "pt12_FacialProbingDepthC",
    "controlvalue": 35
  },
  {
    "controlkey": "pt12_FacialProbingDepthD",
    "controlvalue": 36
  },
  {
    "controlkey": "pt13_FacialProbingDepthM",
    "controlvalue": 37
  },
  {
    "controlkey": "pt13_FacialProbingDepthC",
    "controlvalue": 38
  },
  {
    "controlkey": "pt13_FacialProbingDepthD",
    "controlvalue": 39
  },
  {
    "controlkey": "pt14_FacialProbingDepthM",
    "controlvalue": 40
  },
  {
    "controlkey": "pt14_FacialProbingDepthC",
    "controlvalue": 41
  },
  {
    "controlkey": "pt14_FacialProbingDepthD",
    "controlvalue": 42
  },
  {
    "controlkey": "pt15_FacialProbingDepthM",
    "controlvalue": 43
  },
  {
    "controlkey": "pt15_FacialProbingDepthC",
    "controlvalue": 44
  },
  {
    "controlkey": "pt15_FacialProbingDepthD",
    "controlvalue": 45
  },
  {
    "controlkey": "pt16_FacialProbingDepthM",
    "controlvalue": 46
  },
  {
    "controlkey": "pt16_FacialProbingDepthC",
    "controlvalue": 47
  },
  {
    "controlkey": "pt16_FacialProbingDepthD",
    "controlvalue": 48
  },
  {
    "controlkey": "pt16_LingualProbingDepthM",
    "controlvalue": 49
  },
  {
    "controlkey": "pt16_LingualProbingDepthC",
    "controlvalue": 50
  },
  {
    "controlkey": "pt16_LingualProbingDepthD",
    "controlvalue": 51
  },
  {
    "controlkey": "pt15_LingualProbingDepthM",
    "controlvalue": 52
  },
  {
    "controlkey": "pt15_LingualProbingDepthC",
    "controlvalue": 53
  },
  {
    "controlkey": "pt15_LingualProbingDepthD",
    "controlvalue": 54
  },
  {
    "controlkey": "pt14_LingualProbingDepthM",
    "controlvalue": 55
  },
  {
    "controlkey": "pt14_LingualProbingDepthC",
    "controlvalue": 56
  },
  {
    "controlkey": "pt14_LingualProbingDepthD",
    "controlvalue": 57
  },
  {
    "controlkey": "pt13_LingualProbingDepthM",
    "controlvalue": 58
  },
  {
    "controlkey": "pt13_LingualProbingDepthC",
    "controlvalue": 59
  },
  {
    "controlkey": "pt13_LingualProbingDepthD",
    "controlvalue": 60
  },
  {
    "controlkey": "pt12_LingualProbingDepthM",
    "controlvalue": 61
  },
  {
    "controlkey": "pt12_LingualProbingDepthC",
    "controlvalue": 62
  },
  {
    "controlkey": "pt12_LingualProbingDepthD",
    "controlvalue": 63
  },
  {
    "controlkey": "pt11_LingualProbingDepthM",
    "controlvalue": 64
  },
  {
    "controlkey": "pt11_LingualProbingDepthC",
    "controlvalue": 65
  },
  {
    "controlkey": "pt11_LingualProbingDepthD",
    "controlvalue": 66
  },
  {
    "controlkey": "pt10_LingualProbingDepthM",
    "controlvalue": 67
  },
  {
    "controlkey": "pt10_LingualProbingDepthC",
    "controlvalue": 68
  },
  {
    "controlkey": "pt10_LingualProbingDepthD",
    "controlvalue": 69
  },
  {
    "controlkey": "pt09_LingualProbingDepthM",
    "controlvalue": 70
  },
  {
    "controlkey": "pt09_LingualProbingDepthC",
    "controlvalue": 71
  },
  {
    "controlkey": "pt09_LingualProbingDepthD",
    "controlvalue": 72
  },
  {
    "controlkey": "pt08_LingualProbingDepthD",
    "controlvalue": 73
  },
  {
    "controlkey": "pt08_LingualProbingDepthC",
    "controlvalue": 74
  },
  {
    "controlkey": "pt08_LingualProbingDepthM",
    "controlvalue": 75
  },
  {
    "controlkey": "pt07_LingualProbingDepthD",
    "controlvalue": 76
  },
  {
    "controlkey": "pt07_LingualProbingDepthC",
    "controlvalue": 77
  },
  {
    "controlkey": "pt07_LingualProbingDepthM",
    "controlvalue": 78
  },
  {
    "controlkey": "pt06_LingualProbingDepthD",
    "controlvalue": 79
  },
  {
    "controlkey": "pt06_LingualProbingDepthC",
    "controlvalue": 80
  },
  {
    "controlkey": "pt06_LingualProbingDepthM",
    "controlvalue": 81
  },
  {
    "controlkey": "pt05_LingualProbingDepthD",
    "controlvalue": 82
  },
  {
    "controlkey": "pt05_LingualProbingDepthC",
    "controlvalue": 83
  },
  {
    "controlkey": "pt05_LingualProbingDepthM",
    "controlvalue": 84
  },
  {
    "controlkey": "pt04_LingualProbingDepthD",
    "controlvalue": 85
  },
  {
    "controlkey": "pt04_LingualProbingDepthC",
    "controlvalue": 86
  },
  {
    "controlkey": "pt04_LingualProbingDepthM",
    "controlvalue": 87
  },
  {
    "controlkey": "pt03_LingualProbingDepthD",
    "controlvalue": 88
  },
  {
    "controlkey": "pt03_LingualProbingDepthC",
    "controlvalue": 89
  },
  {
    "controlkey": "pt03_LingualProbingDepthM",
    "controlvalue": 90
  },
  {
    "controlkey": "pt02_LingualProbingDepthD",
    "controlvalue": 91
  },
  {
    "controlkey": "pt02_LingualProbingDepthC",
    "controlvalue": 92
  },
  {
    "controlkey": "pt02_LingualProbingDepthM",
    "controlvalue": 93
  },
  {
    "controlkey": "pt01_LingualProbingDepthD",
    "controlvalue": 94
  },
  {
    "controlkey": "pt01_LingualProbingDepthC",
    "controlvalue": 95
  },
  {
    "controlkey": "pt01_LingualProbingDepthM",
    "controlvalue": 96
  },
  {
    "controlkey": "pt32_LingualProbingDepthD",
    "controlvalue": 97
  },
  {
    "controlkey": "pt32_LingualProbingDepthC",
    "controlvalue": 98
  },
  {
    "controlkey": "pt32_LingualProbingDepthM",
    "controlvalue": 99
  },
  {
    "controlkey": "pt31_LingualProbingDepthD",
    "controlvalue": 100
  },
  {
    "controlkey": "pt31_LingualProbingDepthC",
    "controlvalue": 101
  },
  {
    "controlkey": "pt31_LingualProbingDepthM",
    "controlvalue": 102
  },
  {
    "controlkey": "pt30_LingualProbingDepthD",
    "controlvalue": 103
  },
  {
    "controlkey": "pt30_LingualProbingDepthC",
    "controlvalue": 104
  },
  {
    "controlkey": "pt30_LingualProbingDepthM",
    "controlvalue": 105
  },
  {
    "controlkey": "pt29_LingualProbingDepthD",
    "controlvalue": 106
  },
  {
    "controlkey": "pt29_LingualProbingDepthC",
    "controlvalue": 107
  },
  {
    "controlkey": "pt29_LingualProbingDepthM",
    "controlvalue": 108
  },
  {
    "controlkey": "pt28_LingualProbingDepthD",
    "controlvalue": 109
  },
  {
    "controlkey": "pt28_LingualProbingDepthC",
    "controlvalue": 110
  },
  {
    "controlkey": "pt28_LingualProbingDepthM",
    "controlvalue": 111
  },
  {
    "controlkey": "pt27_LingualProbingDepthD",
    "controlvalue": 112
  },
  {
    "controlkey": "pt27_LingualProbingDepthC",
    "controlvalue": 113
  },
  {
    "controlkey": "pt27_LingualProbingDepthM",
    "controlvalue": 114
  },
  {
    "controlkey": "pt26_LingualProbingDepthD",
    "controlvalue": 115
  },
  {
    "controlkey": "pt26_LingualProbingDepthC",
    "controlvalue": 116
  },
  {
    "controlkey": "pt26_LingualProbingDepthM",
    "controlvalue": 117
  },
  {
    "controlkey": "pt25_LingualProbingDepthD",
    "controlvalue": 118
  },
  {
    "controlkey": "pt25_LingualProbingDepthC",
    "controlvalue": 119
  },
  {
    "controlkey": "pt25_LingualProbingDepthM",
    "controlvalue": 120
  },
  {
    "controlkey": "pt24_LingualProbingDepthM",
    "controlvalue": 121
  },
  {
    "controlkey": "pt24_LingualProbingDepthC",
    "controlvalue": 122
  },
  {
    "controlkey": "pt24_LingualProbingDepthD",
    "controlvalue": 123
  },
  {
    "controlkey": "pt23_LingualProbingDepthM",
    "controlvalue": 124
  },
  {
    "controlkey": "pt23_LingualProbingDepthC",
    "controlvalue": 125
  },
  {
    "controlkey": "pt23_LingualProbingDepthD",
    "controlvalue": 126
  },
  {
    "controlkey": "pt22_LingualProbingDepthM",
    "controlvalue": 127
  },
  {
    "controlkey": "pt22_LingualProbingDepthC",
    "controlvalue": 128
  },
  {
    "controlkey": "pt22_LingualProbingDepthD",
    "controlvalue": 129
  },
  {
    "controlkey": "pt21_LingualProbingDepthM",
    "controlvalue": 130
  },
  {
    "controlkey": "pt21_LingualProbingDepthC",
    "controlvalue": 131
  },
  {
    "controlkey": "pt21_LingualProbingDepthD",
    "controlvalue": 132
  },
  {
    "controlkey": "pt20_LingualProbingDepthM",
    "controlvalue": 133
  },
  {
    "controlkey": "pt20_LingualProbingDepthC",
    "controlvalue": 134
  },
  {
    "controlkey": "pt20_LingualProbingDepthD",
    "controlvalue": 135
  },
  {
    "controlkey": "pt19_LingualProbingDepthM",
    "controlvalue": 136
  },
  {
    "controlkey": "pt19_LingualProbingDepthC",
    "controlvalue": 137
  },
  {
    "controlkey": "pt19_LingualProbingDepthD",
    "controlvalue": 138
  },
  {
    "controlkey": "pt18_LingualProbingDepthM",
    "controlvalue": 139
  },
  {
    "controlkey": "pt18_LingualProbingDepthC",
    "controlvalue": 140
  },
  {
    "controlkey": "pt18_LingualProbingDepthD",
    "controlvalue": 141
  },
  {
    "controlkey": "pt17_LingualProbingDepthM",
    "controlvalue": 142
  },
  {
    "controlkey": "pt17_LingualProbingDepthC",
    "controlvalue": 143
  },
  {
    "controlkey": "pt17_LingualProbingDepthD",
    "controlvalue": 144
  },
  {
    "controlkey": "pt17_FacialProbingDepthM",
    "controlvalue": 145
  },
  {
    "controlkey": "pt17_FacialProbingDepthC",
    "controlvalue": 146
  },
  {
    "controlkey": "pt17_FacialProbingDepthD",
    "controlvalue": 147
  },
  {
    "controlkey": "pt18_FacialProbingDepthM",
    "controlvalue": 148
  },
  {
    "controlkey": "pt18_FacialProbingDepthC",
    "controlvalue": 149
  },
  {
    "controlkey": "pt18_FacialProbingDepthD",
    "controlvalue": 150
  },
  {
    "controlkey": "pt19_FacialProbingDepthM",
    "controlvalue": 151
  },
  {
    "controlkey": "pt19_FacialProbingDepthC",
    "controlvalue": 152
  },
  {
    "controlkey": "pt19_FacialProbingDepthD",
    "controlvalue": 153
  },
  {
    "controlkey": "pt20_FacialProbingDepthM",
    "controlvalue": 154
  },
  {
    "controlkey": "pt20_FacialProbingDepthC",
    "controlvalue": 155
  },
  {
    "controlkey": "pt20_FacialProbingDepthD",
    "controlvalue": 156
  },
  {
    "controlkey": "pt21_FacialProbingDepthM",
    "controlvalue": 157
  },
  {
    "controlkey": "pt21_FacialProbingDepthC",
    "controlvalue": 158
  },
  {
    "controlkey": "pt21_FacialProbingDepthD",
    "controlvalue": 159
  },
  {
    "controlkey": "pt22_FacialProbingDepthM",
    "controlvalue": 160
  },
  {
    "controlkey": "pt22_FacialProbingDepthC",
    "controlvalue": 161
  },
  {
    "controlkey": "pt22_FacialProbingDepthD",
    "controlvalue": 162
  },
  {
    "controlkey": "pt23_FacialProbingDepthM",
    "controlvalue": 163
  },
  {
    "controlkey": "pt23_FacialProbingDepthC",
    "controlvalue": 164
  },
  {
    "controlkey": "pt23_FacialProbingDepthD",
    "controlvalue": 165
  },
  {
    "controlkey": "pt24_FacialProbingDepthM",
    "controlvalue": 166
  },
  {
    "controlkey": "pt24_FacialProbingDepthC",
    "controlvalue": 167
  },
  {
    "controlkey": "pt24_FacialProbingDepthD",
    "controlvalue": 168
  },
  {
    "controlkey": "pt25_FacialProbingDepthD",
    "controlvalue": 169
  },
  {
    "controlkey": "pt25_FacialProbingDepthC",
    "controlvalue": 170
  },
  {
    "controlkey": "pt25_FacialProbingDepthM",
    "controlvalue": 171
  },
  {
    "controlkey": "pt26_FacialProbingDepthD",
    "controlvalue": 172
  },
  {
    "controlkey": "pt26_FacialProbingDepthC",
    "controlvalue": 173
  },
  {
    "controlkey": "pt26_FacialProbingDepthM",
    "controlvalue": 174
  },
  {
    "controlkey": "pt27_FacialProbingDepthD",
    "controlvalue": 175
  },
  {
    "controlkey": "pt27_FacialProbingDepthC",
    "controlvalue": 176
  },
  {
    "controlkey": "pt27_FacialProbingDepthM",
    "controlvalue": 177
  },
  {
    "controlkey": "pt28_FacialProbingDepthD",
    "controlvalue": 178
  },
  {
    "controlkey": "pt28_FacialProbingDepthC",
    "controlvalue": 179
  },
  {
    "controlkey": "pt28_FacialProbingDepthM",
    "controlvalue": 180
  },
  {
    "controlkey": "pt29_FacialProbingDepthD",
    "controlvalue": 181
  },
  {
    "controlkey": "pt29_FacialProbingDepthC",
    "controlvalue": 182
  },
  {
    "controlkey": "pt29_FacialProbingDepthM",
    "controlvalue": 183
  },
  {
    "controlkey": "pt30_FacialProbingDepthD",
    "controlvalue": 184
  },
  {
    "controlkey": "pt30_FacialProbingDepthC",
    "controlvalue": 185
  },
  {
    "controlkey": "pt30_FacialProbingDepthM",
    "controlvalue": 186
  },
  {
    "controlkey": "pt31_FacialProbingDepthD",
    "controlvalue": 187
  },
  {
    "controlkey": "pt31_FacialProbingDepthC",
    "controlvalue": 188
  },
  {
    "controlkey": "pt31_FacialProbingDepthM",
    "controlvalue": 189
  },
  {
    "controlkey": "pt32_FacialProbingDepthD",
    "controlvalue": 190
  },
  {
    "controlkey": "pt32_FacialProbingDepthC",
    "controlvalue": 191
  },
  {
    "controlkey": "pt32_FacialProbingDepthM",
    "controlvalue": 192
  },
  {
    "controlkey": "pt01_FacialGingovalMarginD",
    "controlvalue": 193
  },
  {
    "controlkey": "pt01_FacialGingovalMarginC",
    "controlvalue": 194
  },
  {
    "controlkey": "pt01_FacialGingovalMarginM",
    "controlvalue": 195
  },
  {
    "controlkey": "pt02_FacialGingovalMarginD",
    "controlvalue": 196
  },
  {
    "controlkey": "pt02_FacialGingovalMarginC",
    "controlvalue": 197
  },
  {
    "controlkey": "pt02_FacialGingovalMarginM",
    "controlvalue": 198
  },
  {
    "controlkey": "pt03_FacialGingovalMarginD",
    "controlvalue": 199
  },
  {
    "controlkey": "pt03_FacialGingovalMarginC",
    "controlvalue": 200
  },
  {
    "controlkey": "pt03_FacialGingovalMarginM",
    "controlvalue": 201
  },
  {
    "controlkey": "pt04_FacialGingovalMarginD",
    "controlvalue": 202
  },
  {
    "controlkey": "pt04_FacialGingovalMarginC",
    "controlvalue": 203
  },
  {
    "controlkey": "pt04_FacialGingovalMarginM",
    "controlvalue": 204
  },
  {
    "controlkey": "pt05_FacialGingovalMarginD",
    "controlvalue": 205
  },
  {
    "controlkey": "pt05_FacialGingovalMarginC",
    "controlvalue": 206
  },
  {
    "controlkey": "pt05_FacialGingovalMarginM",
    "controlvalue": 207
  },
  {
    "controlkey": "pt06_FacialGingovalMarginD",
    "controlvalue": 208
  },
  {
    "controlkey": "pt06_FacialGingovalMarginC",
    "controlvalue": 209
  },
  {
    "controlkey": "pt06_FacialGingovalMarginM",
    "controlvalue": 210
  },
  {
    "controlkey": "pt07_FacialGingovalMarginD",
    "controlvalue": 211
  },
  {
    "controlkey": "pt07_FacialGingovalMarginC",
    "controlvalue": 212
  },
  {
    "controlkey": "pt07_FacialGingovalMarginM",
    "controlvalue": 213
  },
  {
    "controlkey": "pt08_FacialGingovalMarginD",
    "controlvalue": 214
  },
  {
    "controlkey": "pt08_FacialGingovalMarginC",
    "controlvalue": 215
  },
  {
    "controlkey": "pt08_FacialGingovalMarginM",
    "controlvalue": 216
  },
  {
    "controlkey": "pt09_FacialGingovalMarginM",
    "controlvalue": 217
  },
  {
    "controlkey": "pt09_FacialGingovalMarginC",
    "controlvalue": 218
  },
  {
    "controlkey": "pt09_FacialGingovalMarginD",
    "controlvalue": 219
  },
  {
    "controlkey": "pt10_FacialGingovalMarginM",
    "controlvalue": 220
  },
  {
    "controlkey": "pt10_FacialGingovalMarginC",
    "controlvalue": 221
  },
  {
    "controlkey": "pt10_FacialGingovalMarginD",
    "controlvalue": 222
  },
  {
    "controlkey": "pt11_FacialGingovalMarginM",
    "controlvalue": 223
  },
  {
    "controlkey": "pt11_FacialGingovalMarginC",
    "controlvalue": 224
  },
  {
    "controlkey": "pt11_FacialGingovalMarginD",
    "controlvalue": 225
  },
  {
    "controlkey": "pt12_FacialGingovalMarginM",
    "controlvalue": 226
  },
  {
    "controlkey": "pt12_FacialGingovalMarginC",
    "controlvalue": 227
  },
  {
    "controlkey": "pt12_FacialGingovalMarginD",
    "controlvalue": 228
  },
  {
    "controlkey": "pt13_FacialGingovalMarginM",
    "controlvalue": 229
  },
  {
    "controlkey": "pt13_FacialGingovalMarginC",
    "controlvalue": 230
  },
  {
    "controlkey": "pt13_FacialGingovalMarginD",
    "controlvalue": 231
  },
  {
    "controlkey": "pt14_FacialGingovalMarginM",
    "controlvalue": 232
  },
  {
    "controlkey": "pt14_FacialGingovalMarginC",
    "controlvalue": 233
  },
  {
    "controlkey": "pt14_FacialGingovalMarginD",
    "controlvalue": 234
  },
  {
    "controlkey": "pt15_FacialGingovalMarginM",
    "controlvalue": 235
  },
  {
    "controlkey": "pt15_FacialGingovalMarginC",
    "controlvalue": 236
  },
  {
    "controlkey": "pt15_FacialGingovalMarginD",
    "controlvalue": 237
  },
  {
    "controlkey": "pt16_FacialGingovalMarginM",
    "controlvalue": 238
  },
  {
    "controlkey": "pt16_FacialGingovalMarginC",
    "controlvalue": 239
  },
  {
    "controlkey": "pt16_FacialGingovalMarginD",
    "controlvalue": 240
  },
  {
    "controlkey": "pt16_LingualGingovalMarginM",
    "controlvalue": 241
  },
  {
    "controlkey": "pt16_LingualGingovalMarginC",
    "controlvalue": 242
  },
  {
    "controlkey": "pt16_LingualGingovalMarginD",
    "controlvalue": 243
  },
  {
    "controlkey": "pt15_LingualGingovalMarginM",
    "controlvalue": 244
  },
  {
    "controlkey": "pt15_LingualGingovalMarginC",
    "controlvalue": 245
  },
  {
    "controlkey": "pt15_LingualGingovalMarginD",
    "controlvalue": 246
  },
  {
    "controlkey": "pt14_LingualGingovalMarginM",
    "controlvalue": 247
  },
  {
    "controlkey": "pt14_LingualGingovalMarginC",
    "controlvalue": 248
  },
  {
    "controlkey": "pt14_LingualGingovalMarginD",
    "controlvalue": 249
  },
  {
    "controlkey": "pt13_LingualGingovalMarginM",
    "controlvalue": 250
  },
  {
    "controlkey": "pt13_LingualGingovalMarginC",
    "controlvalue": 251
  },
  {
    "controlkey": "pt13_LingualGingovalMarginD",
    "controlvalue": 252
  },
  {
    "controlkey": "pt12_LingualGingovalMarginM",
    "controlvalue": 253
  },
  {
    "controlkey": "pt12_LingualGingovalMarginC",
    "controlvalue": 254
  },
  {
    "controlkey": "pt12_LingualGingovalMarginD",
    "controlvalue": 255
  },
  {
    "controlkey": "pt11_LingualGingovalMarginM",
    "controlvalue": 256
  },
  {
    "controlkey": "pt11_LingualGingovalMarginC",
    "controlvalue": 257
  },
  {
    "controlkey": "pt11_LingualGingovalMarginD",
    "controlvalue": 258
  },
  {
    "controlkey": "pt10_LingualGingovalMarginM",
    "controlvalue": 259
  },
  {
    "controlkey": "pt10_LingualGingovalMarginC",
    "controlvalue": 260
  },
  {
    "controlkey": "pt10_LingualGingovalMarginD",
    "controlvalue": 261
  },
  {
    "controlkey": "pt09_LingualGingovalMarginM",
    "controlvalue": 262
  },
  {
    "controlkey": "pt09_LingualGingovalMarginC",
    "controlvalue": 263
  },
  {
    "controlkey": "pt09_LingualGingovalMarginD",
    "controlvalue": 264
  },
  {
    "controlkey": "pt08_LingualGingovalMarginD",
    "controlvalue": 265
  },
  {
    "controlkey": "pt08_LingualGingovalMarginC",
    "controlvalue": 266
  },
  {
    "controlkey": "pt08_LingualGingovalMarginM",
    "controlvalue": 267
  },
  {
    "controlkey": "pt07_LingualGingovalMarginD",
    "controlvalue": 268
  },
  {
    "controlkey": "pt07_LingualGingovalMarginC",
    "controlvalue": 269
  },
  {
    "controlkey": "pt07_LingualGingovalMarginM",
    "controlvalue": 270
  },
  {
    "controlkey": "pt06_LingualGingovalMarginD",
    "controlvalue": 271
  },
  {
    "controlkey": "pt06_LingualGingovalMarginC",
    "controlvalue": 272
  },
  {
    "controlkey": "pt06_LingualGingovalMarginM",
    "controlvalue": 273
  },
  {
    "controlkey": "pt05_LingualGingovalMarginD",
    "controlvalue": 274
  },
  {
    "controlkey": "pt05_LingualGingovalMarginC",
    "controlvalue": 275
  },
  {
    "controlkey": "pt05_LingualGingovalMarginM",
    "controlvalue": 276
  },
  {
    "controlkey": "pt04_LingualGingovalMarginD",
    "controlvalue": 277
  },
  {
    "controlkey": "pt04_LingualGingovalMarginC",
    "controlvalue": 278
  },
  {
    "controlkey": "pt04_LingualGingovalMarginM",
    "controlvalue": 279
  },
  {
    "controlkey": "pt03_LingualGingovalMarginD",
    "controlvalue": 280
  },
  {
    "controlkey": "pt03_LingualGingovalMarginC",
    "controlvalue": 281
  },
  {
    "controlkey": "pt03_LingualGingovalMarginM",
    "controlvalue": 282
  },
  {
    "controlkey": "pt02_LingualGingovalMarginD",
    "controlvalue": 283
  },
  {
    "controlkey": "pt02_LingualGingovalMarginC",
    "controlvalue": 284
  },
  {
    "controlkey": "pt02_LingualGingovalMarginM",
    "controlvalue": 285
  },
  {
    "controlkey": "pt01_LingualGingovalMarginD",
    "controlvalue": 286
  },
  {
    "controlkey": "pt01_LingualGingovalMarginC",
    "controlvalue": 287
  },
  {
    "controlkey": "pt01_LingualGingovalMarginM",
    "controlvalue": 288
  },
  {
    "controlkey": "pt32_LingualGingovalMarginD",
    "controlvalue": 289
  },
  {
    "controlkey": "pt32_LingualGingovalMarginC",
    "controlvalue": 290
  },
  {
    "controlkey": "pt32_LingualGingovalMarginM",
    "controlvalue": 291
  },
  {
    "controlkey": "pt31_LingualGingovalMarginD",
    "controlvalue": 292
  },
  {
    "controlkey": "pt31_LingualGingovalMarginC",
    "controlvalue": 293
  },
  {
    "controlkey": "pt31_LingualGingovalMarginM",
    "controlvalue": 294
  },
  {
    "controlkey": "pt30_LingualGingovalMarginD",
    "controlvalue": 295
  },
  {
    "controlkey": "pt30_LingualGingovalMarginC",
    "controlvalue": 296
  },
  {
    "controlkey": "pt30_LingualGingovalMarginM",
    "controlvalue": 297
  },
  {
    "controlkey": "pt29_LingualGingovalMarginD",
    "controlvalue": 298
  },
  {
    "controlkey": "pt29_LingualGingovalMarginC",
    "controlvalue": 299
  },
  {
    "controlkey": "pt29_LingualGingovalMarginM",
    "controlvalue": 300
  },
  {
    "controlkey": "pt28_LingualGingovalMarginD",
    "controlvalue": 301
  },
  {
    "controlkey": "pt28_LingualGingovalMarginC",
    "controlvalue": 302
  },
  {
    "controlkey": "pt28_LingualGingovalMarginM",
    "controlvalue": 303
  },
  {
    "controlkey": "pt27_LingualGingovalMarginD",
    "controlvalue": 304
  },
  {
    "controlkey": "pt27_LingualGingovalMarginC",
    "controlvalue": 305
  },
  {
    "controlkey": "pt27_LingualGingovalMarginM",
    "controlvalue": 306
  },
  {
    "controlkey": "pt26_LingualGingovalMarginD",
    "controlvalue": 307
  },
  {
    "controlkey": "pt26_LingualGingovalMarginC",
    "controlvalue": 308
  },
  {
    "controlkey": "pt26_LingualGingovalMarginM",
    "controlvalue": 309
  },
  {
    "controlkey": "pt25_LingualGingovalMarginD",
    "controlvalue": 310
  },
  {
    "controlkey": "pt25_LingualGingovalMarginC",
    "controlvalue": 311
  },
  {
    "controlkey": "pt25_LingualGingovalMarginM",
    "controlvalue": 312
  },
  {
    "controlkey": "pt24_LingualGingovalMarginM",
    "controlvalue": 313
  },
  {
    "controlkey": "pt24_LingualGingovalMarginC",
    "controlvalue": 314
  },
  {
    "controlkey": "pt24_LingualGingovalMarginD",
    "controlvalue": 315
  },
  {
    "controlkey": "pt23_LingualGingovalMarginM",
    "controlvalue": 316
  },
  {
    "controlkey": "pt23_LingualGingovalMarginC",
    "controlvalue": 317
  },
  {
    "controlkey": "pt23_LingualGingovalMarginD",
    "controlvalue": 318
  },
  {
    "controlkey": "pt22_LingualGingovalMarginM",
    "controlvalue": 319
  },
  {
    "controlkey": "pt22_LingualGingovalMarginC",
    "controlvalue": 320
  },
  {
    "controlkey": "pt22_LingualGingovalMarginD",
    "controlvalue": 321
  },
  {
    "controlkey": "pt21_LingualGingovalMarginM",
    "controlvalue": 322
  },
  {
    "controlkey": "pt21_LingualGingovalMarginC",
    "controlvalue": 323
  },
  {
    "controlkey": "pt21_LingualGingovalMarginD",
    "controlvalue": 324
  },
  {
    "controlkey": "pt20_LingualGingovalMarginM",
    "controlvalue": 325
  },
  {
    "controlkey": "pt20_LingualGingovalMarginC",
    "controlvalue": 326
  },
  {
    "controlkey": "pt20_LingualGingovalMarginD",
    "controlvalue": 327
  },
  {
    "controlkey": "pt19_LingualGingovalMarginM",
    "controlvalue": 328
  },
  {
    "controlkey": "pt19_LingualGingovalMarginC",
    "controlvalue": 329
  },
  {
    "controlkey": "pt19_LingualGingovalMarginD",
    "controlvalue": 330
  },
  {
    "controlkey": "pt18_LingualGingovalMarginM",
    "controlvalue": 331
  },
  {
    "controlkey": "pt18_LingualGingovalMarginC",
    "controlvalue": 332
  },
  {
    "controlkey": "pt18_LingualGingovalMarginD",
    "controlvalue": 333
  },
  {
    "controlkey": "pt17_LingualGingovalMarginM",
    "controlvalue": 334
  },
  {
    "controlkey": "pt17_LingualGingovalMarginC",
    "controlvalue": 335
  },
  {
    "controlkey": "pt17_LingualGingovalMarginD",
    "controlvalue": 336
  },
  {
    "controlkey": "pt17_FacialGingovalMarginM",
    "controlvalue": 337
  },
  {
    "controlkey": "pt17_FacialGingovalMarginC",
    "controlvalue": 338
  },
  {
    "controlkey": "pt17_FacialGingovalMarginD",
    "controlvalue": 339
  },
  {
    "controlkey": "pt18_FacialGingovalMarginM",
    "controlvalue": 340
  },
  {
    "controlkey": "pt18_FacialGingovalMarginC",
    "controlvalue": 341
  },
  {
    "controlkey": "pt18_FacialGingovalMarginD",
    "controlvalue": 342
  },
  {
    "controlkey": "pt19_FacialGingovalMarginM",
    "controlvalue": 343
  },
  {
    "controlkey": "pt19_FacialGingovalMarginC",
    "controlvalue": 344
  },
  {
    "controlkey": "pt19_FacialGingovalMarginD",
    "controlvalue": 345
  },
  {
    "controlkey": "pt20_FacialGingovalMarginM",
    "controlvalue": 346
  },
  {
    "controlkey": "pt20_FacialGingovalMarginC",
    "controlvalue": 347
  },
  {
    "controlkey": "pt20_FacialGingovalMarginD",
    "controlvalue": 348
  },
  {
    "controlkey": "pt21_FacialGingovalMarginM",
    "controlvalue": 349
  },
  {
    "controlkey": "pt21_FacialGingovalMarginC",
    "controlvalue": 350
  },
  {
    "controlkey": "pt21_FacialGingovalMarginD",
    "controlvalue": 351
  },
  {
    "controlkey": "pt22_FacialGingovalMarginM",
    "controlvalue": 352
  },
  {
    "controlkey": "pt22_FacialGingovalMarginC",
    "controlvalue": 353
  },
  {
    "controlkey": "pt22_FacialGingovalMarginD",
    "controlvalue": 354
  },
  {
    "controlkey": "pt23_FacialGingovalMarginM",
    "controlvalue": 355
  },
  {
    "controlkey": "pt23_FacialGingovalMarginC",
    "controlvalue": 356
  },
  {
    "controlkey": "pt23_FacialGingovalMarginD",
    "controlvalue": 357
  },
  {
    "controlkey": "pt24_FacialGingovalMarginM",
    "controlvalue": 358
  },
  {
    "controlkey": "pt24_FacialGingovalMarginC",
    "controlvalue": 359
  },
  {
    "controlkey": "pt24_FacialGingovalMarginD",
    "controlvalue": 360
  },
  {
    "controlkey": "pt25_FacialGingovalMarginD",
    "controlvalue": 361
  },
  {
    "controlkey": "pt25_FacialGingovalMarginC",
    "controlvalue": 362
  },
  {
    "controlkey": "pt25_FacialGingovalMarginM",
    "controlvalue": 363
  },
  {
    "controlkey": "pt26_FacialGingovalMarginD",
    "controlvalue": 364
  },
  {
    "controlkey": "pt26_FacialGingovalMarginC",
    "controlvalue": 365
  },
  {
    "controlkey": "pt26_FacialGingovalMarginM",
    "controlvalue": 366
  },
  {
    "controlkey": "pt27_FacialGingovalMarginD",
    "controlvalue": 367
  },
  {
    "controlkey": "pt27_FacialGingovalMarginC",
    "controlvalue": 368
  },
  {
    "controlkey": "pt27_FacialGingovalMarginM",
    "controlvalue": 369
  },
  {
    "controlkey": "pt28_FacialGingovalMarginD",
    "controlvalue": 370
  },
  {
    "controlkey": "pt28_FacialGingovalMarginC",
    "controlvalue": 371
  },
  {
    "controlkey": "pt28_FacialGingovalMarginM",
    "controlvalue": 372
  },
  {
    "controlkey": "pt29_FacialGingovalMarginD",
    "controlvalue": 373
  },
  {
    "controlkey": "pt29_FacialGingovalMarginC",
    "controlvalue": 374
  },
  {
    "controlkey": "pt29_FacialGingovalMarginM",
    "controlvalue": 375
  },
  {
    "controlkey": "pt30_FacialGingovalMarginD",
    "controlvalue": 376
  },
  {
    "controlkey": "pt30_FacialGingovalMarginC",
    "controlvalue": 377
  },
  {
    "controlkey": "pt30_FacialGingovalMarginM",
    "controlvalue": 378
  },
  {
    "controlkey": "pt31_FacialGingovalMarginD",
    "controlvalue": 379
  },
  {
    "controlkey": "pt31_FacialGingovalMarginC",
    "controlvalue": 380
  },
  {
    "controlkey": "pt31_FacialGingovalMarginM",
    "controlvalue": 381
  },
  {
    "controlkey": "pt32_FacialGingovalMarginD",
    "controlvalue": 382
  },
  {
    "controlkey": "pt32_FacialGingovalMarginC",
    "controlvalue": 383
  },
  {
    "controlkey": "pt32_FacialGingovalMarginM",
    "controlvalue": 384
  },
  {
    "controlkey": "pt01_FacialClinicalAttachmentLevelD",
    "controlvalue": 385
  },
  {
    "controlkey": "pt01_FacialClinicalAttachmentLevelC",
    "controlvalue": 386
  },
  {
    "controlkey": "pt01_FacialClinicalAttachmentLevelM",
    "controlvalue": 387
  },
  {
    "controlkey": "pt02_FacialClinicalAttachmentLevelD",
    "controlvalue": 388
  },
  {
    "controlkey": "pt02_FacialClinicalAttachmentLevelC",
    "controlvalue": 389
  },
  {
    "controlkey": "pt02_FacialClinicalAttachmentLevelM",
    "controlvalue": 390
  },
  {
    "controlkey": "pt03_FacialClinicalAttachmentLevelD",
    "controlvalue": 391
  },
  {
    "controlkey": "pt03_FacialClinicalAttachmentLevelC",
    "controlvalue": 392
  },
  {
    "controlkey": "pt03_FacialClinicalAttachmentLevelM",
    "controlvalue": 393
  },
  {
    "controlkey": "pt04_FacialClinicalAttachmentLevelD",
    "controlvalue": 394
  },
  {
    "controlkey": "pt04_FacialClinicalAttachmentLevelC",
    "controlvalue": 395
  },
  {
    "controlkey": "pt04_FacialClinicalAttachmentLevelM",
    "controlvalue": 396
  },
  {
    "controlkey": "pt05_FacialClinicalAttachmentLevelD",
    "controlvalue": 397
  },
  {
    "controlkey": "pt05_FacialClinicalAttachmentLevelC",
    "controlvalue": 398
  },
  {
    "controlkey": "pt05_FacialClinicalAttachmentLevelM",
    "controlvalue": 399
  },
  {
    "controlkey": "pt06_FacialClinicalAttachmentLevelD",
    "controlvalue": 400
  },
  {
    "controlkey": "pt06_FacialClinicalAttachmentLevelC",
    "controlvalue": 401
  },
  {
    "controlkey": "pt06_FacialClinicalAttachmentLevelM",
    "controlvalue": 402
  },
  {
    "controlkey": "pt07_FacialClinicalAttachmentLevelD",
    "controlvalue": 403
  },
  {
    "controlkey": "pt07_FacialClinicalAttachmentLevelC",
    "controlvalue": 404
  },
  {
    "controlkey": "pt07_FacialClinicalAttachmentLevelM",
    "controlvalue": 405
  },
  {
    "controlkey": "pt08_FacialClinicalAttachmentLevelD",
    "controlvalue": 406
  },
  {
    "controlkey": "pt08_FacialClinicalAttachmentLevelC",
    "controlvalue": 407
  },
  {
    "controlkey": "pt08_FacialClinicalAttachmentLevelM",
    "controlvalue": 408
  },
  {
    "controlkey": "pt09_FacialClinicalAttachmentLevelM",
    "controlvalue": 409
  },
  {
    "controlkey": "pt09_FacialClinicalAttachmentLevelC",
    "controlvalue": 410
  },
  {
    "controlkey": "pt09_FacialClinicalAttachmentLevelD",
    "controlvalue": 411
  },
  {
    "controlkey": "pt10_FacialClinicalAttachmentLevelM",
    "controlvalue": 412
  },
  {
    "controlkey": "pt10_FacialClinicalAttachmentLevelC",
    "controlvalue": 413
  },
  {
    "controlkey": "pt10_FacialClinicalAttachmentLevelD",
    "controlvalue": 414
  },
  {
    "controlkey": "pt11_FacialClinicalAttachmentLevelM",
    "controlvalue": 415
  },
  {
    "controlkey": "pt11_FacialClinicalAttachmentLevelC",
    "controlvalue": 416
  },
  {
    "controlkey": "pt11_FacialClinicalAttachmentLevelD",
    "controlvalue": 417
  },
  {
    "controlkey": "pt12_FacialClinicalAttachmentLevelM",
    "controlvalue": 418
  },
  {
    "controlkey": "pt12_FacialClinicalAttachmentLevelC",
    "controlvalue": 419
  },
  {
    "controlkey": "pt12_FacialClinicalAttachmentLevelD",
    "controlvalue": 420
  },
  {
    "controlkey": "pt13_FacialClinicalAttachmentLevelM",
    "controlvalue": 421
  },
  {
    "controlkey": "pt13_FacialClinicalAttachmentLevelC",
    "controlvalue": 422
  },
  {
    "controlkey": "pt13_FacialClinicalAttachmentLevelD",
    "controlvalue": 423
  },
  {
    "controlkey": "pt14_FacialClinicalAttachmentLevelM",
    "controlvalue": 424
  },
  {
    "controlkey": "pt14_FacialClinicalAttachmentLevelC",
    "controlvalue": 425
  },
  {
    "controlkey": "pt14_FacialClinicalAttachmentLevelD",
    "controlvalue": 426
  },
  {
    "controlkey": "pt15_FacialClinicalAttachmentLevelM",
    "controlvalue": 427
  },
  {
    "controlkey": "pt15_FacialClinicalAttachmentLevelC",
    "controlvalue": 428
  },
  {
    "controlkey": "pt15_FacialClinicalAttachmentLevelD",
    "controlvalue": 429
  },
  {
    "controlkey": "pt16_FacialClinicalAttachmentLevelM",
    "controlvalue": 430
  },
  {
    "controlkey": "pt16_FacialClinicalAttachmentLevelC",
    "controlvalue": 431
  },
  {
    "controlkey": "pt16_FacialClinicalAttachmentLevelD",
    "controlvalue": 432
  },
  {
    "controlkey": "pt16_LingualClinicalAttachmentLevelM",
    "controlvalue": 433
  },
  {
    "controlkey": "pt16_LingualClinicalAttachmentLevelC",
    "controlvalue": 434
  },
  {
    "controlkey": "pt16_LingualClinicalAttachmentLevelD",
    "controlvalue": 435
  },
  {
    "controlkey": "pt15_LingualClinicalAttachmentLevelM",
    "controlvalue": 436
  },
  {
    "controlkey": "pt15_LingualClinicalAttachmentLevelC",
    "controlvalue": 437
  },
  {
    "controlkey": "pt15_LingualClinicalAttachmentLevelD",
    "controlvalue": 438
  },
  {
    "controlkey": "pt14_LingualClinicalAttachmentLevelM",
    "controlvalue": 439
  },
  {
    "controlkey": "pt14_LingualClinicalAttachmentLevelC",
    "controlvalue": 440
  },
  {
    "controlkey": "pt14_LingualClinicalAttachmentLevelD",
    "controlvalue": 441
  },
  {
    "controlkey": "pt13_LingualClinicalAttachmentLevelM",
    "controlvalue": 442
  },
  {
    "controlkey": "pt13_LingualClinicalAttachmentLevelC",
    "controlvalue": 443
  },
  {
    "controlkey": "pt13_LingualClinicalAttachmentLevelD",
    "controlvalue": 444
  },
  {
    "controlkey": "pt12_LingualClinicalAttachmentLevelM",
    "controlvalue": 445
  },
  {
    "controlkey": "pt12_LingualClinicalAttachmentLevelC",
    "controlvalue": 446
  },
  {
    "controlkey": "pt12_LingualClinicalAttachmentLevelD",
    "controlvalue": 447
  },
  {
    "controlkey": "pt11_LingualClinicalAttachmentLevelM",
    "controlvalue": 448
  },
  {
    "controlkey": "pt11_LingualClinicalAttachmentLevelC",
    "controlvalue": 449
  },
  {
    "controlkey": "pt11_LingualClinicalAttachmentLevelD",
    "controlvalue": 450
  },
  {
    "controlkey": "pt10_LingualClinicalAttachmentLevelM",
    "controlvalue": 451
  },
  {
    "controlkey": "pt10_LingualClinicalAttachmentLevelC",
    "controlvalue": 452
  },
  {
    "controlkey": "pt10_LingualClinicalAttachmentLevelD",
    "controlvalue": 453
  },
  {
    "controlkey": "pt09_LingualClinicalAttachmentLevelM",
    "controlvalue": 454
  },
  {
    "controlkey": "pt09_LingualClinicalAttachmentLevelC",
    "controlvalue": 455
  },
  {
    "controlkey": "pt09_LingualClinicalAttachmentLevelD",
    "controlvalue": 456
  },
  {
    "controlkey": "pt08_LingualClinicalAttachmentLevelD",
    "controlvalue": 457
  },
  {
    "controlkey": "pt08_LingualClinicalAttachmentLevelC",
    "controlvalue": 458
  },
  {
    "controlkey": "pt08_LingualClinicalAttachmentLevelM",
    "controlvalue": 459
  },
  {
    "controlkey": "pt07_LingualClinicalAttachmentLevelD",
    "controlvalue": 460
  },
  {
    "controlkey": "pt07_LingualClinicalAttachmentLevelC",
    "controlvalue": 461
  },
  {
    "controlkey": "pt07_LingualClinicalAttachmentLevelM",
    "controlvalue": 462
  },
  {
    "controlkey": "pt06_LingualClinicalAttachmentLevelD",
    "controlvalue": 463
  },
  {
    "controlkey": "pt06_LingualClinicalAttachmentLevelC",
    "controlvalue": 464
  },
  {
    "controlkey": "pt06_LingualClinicalAttachmentLevelM",
    "controlvalue": 465
  },
  {
    "controlkey": "pt05_LingualClinicalAttachmentLevelD",
    "controlvalue": 466
  },
  {
    "controlkey": "pt05_LingualClinicalAttachmentLevelC",
    "controlvalue": 467
  },
  {
    "controlkey": "pt05_LingualClinicalAttachmentLevelM",
    "controlvalue": 468
  },
  {
    "controlkey": "pt04_LingualClinicalAttachmentLevelD",
    "controlvalue": 469
  },
  {
    "controlkey": "pt04_LingualClinicalAttachmentLevelC",
    "controlvalue": 470
  },
  {
    "controlkey": "pt04_LingualClinicalAttachmentLevelM",
    "controlvalue": 471
  },
  {
    "controlkey": "pt03_LingualClinicalAttachmentLevelD",
    "controlvalue": 472
  },
  {
    "controlkey": "pt03_LingualClinicalAttachmentLevelC",
    "controlvalue": 473
  },
  {
    "controlkey": "pt03_LingualClinicalAttachmentLevelM",
    "controlvalue": 474
  },
  {
    "controlkey": "pt02_LingualClinicalAttachmentLevelD",
    "controlvalue": 475
  },
  {
    "controlkey": "pt02_LingualClinicalAttachmentLevelC",
    "controlvalue": 476
  },
  {
    "controlkey": "pt02_LingualClinicalAttachmentLevelM",
    "controlvalue": 477
  },
  {
    "controlkey": "pt01_LingualClinicalAttachmentLevelD",
    "controlvalue": 478
  },
  {
    "controlkey": "pt01_LingualClinicalAttachmentLevelC",
    "controlvalue": 479
  },
  {
    "controlkey": "pt01_LingualClinicalAttachmentLevelM",
    "controlvalue": 480
  },
  {
    "controlkey": "pt32_LingualClinicalAttachmentLevelD",
    "controlvalue": 481
  },
  {
    "controlkey": "pt32_LingualClinicalAttachmentLevelC",
    "controlvalue": 482
  },
  {
    "controlkey": "pt32_LingualClinicalAttachmentLevelM",
    "controlvalue": 483
  },
  {
    "controlkey": "pt31_LingualClinicalAttachmentLevelD",
    "controlvalue": 484
  },
  {
    "controlkey": "pt31_LingualClinicalAttachmentLevelC",
    "controlvalue": 485
  },
  {
    "controlkey": "pt31_LingualClinicalAttachmentLevelM",
    "controlvalue": 486
  },
  {
    "controlkey": "pt30_LingualClinicalAttachmentLevelD",
    "controlvalue": 487
  },
  {
    "controlkey": "pt30_LingualClinicalAttachmentLevelC",
    "controlvalue": 488
  },
  {
    "controlkey": "pt30_LingualClinicalAttachmentLevelM",
    "controlvalue": 489
  },
  {
    "controlkey": "pt29_LingualClinicalAttachmentLevelD",
    "controlvalue": 490
  },
  {
    "controlkey": "pt29_LingualClinicalAttachmentLevelC",
    "controlvalue": 491
  },
  {
    "controlkey": "pt29_LingualClinicalAttachmentLevelM",
    "controlvalue": 492
  },
  {
    "controlkey": "pt28_LingualClinicalAttachmentLevelD",
    "controlvalue": 493
  },
  {
    "controlkey": "pt28_LingualClinicalAttachmentLevelC",
    "controlvalue": 494
  },
  {
    "controlkey": "pt28_LingualClinicalAttachmentLevelM",
    "controlvalue": 495
  },
  {
    "controlkey": "pt27_LingualClinicalAttachmentLevelD",
    "controlvalue": 496
  },
  {
    "controlkey": "pt27_LingualClinicalAttachmentLevelC",
    "controlvalue": 497
  },
  {
    "controlkey": "pt27_LingualClinicalAttachmentLevelM",
    "controlvalue": 498
  },
  {
    "controlkey": "pt26_LingualClinicalAttachmentLevelD",
    "controlvalue": 499
  },
  {
    "controlkey": "pt26_LingualClinicalAttachmentLevelC",
    "controlvalue": 500
  },
  {
    "controlkey": "pt26_LingualClinicalAttachmentLevelM",
    "controlvalue": 501
  },
  {
    "controlkey": "pt25_LingualClinicalAttachmentLevelD",
    "controlvalue": 502
  },
  {
    "controlkey": "pt25_LingualClinicalAttachmentLevelC",
    "controlvalue": 503
  },
  {
    "controlkey": "pt25_LingualClinicalAttachmentLevelM",
    "controlvalue": 504
  },
  {
    "controlkey": "pt24_LingualClinicalAttachmentLevelM",
    "controlvalue": 505
  },
  {
    "controlkey": "pt24_LingualClinicalAttachmentLevelC",
    "controlvalue": 506
  },
  {
    "controlkey": "pt24_LingualClinicalAttachmentLevelD",
    "controlvalue": 507
  },
  {
    "controlkey": "pt23_LingualClinicalAttachmentLevelM",
    "controlvalue": 508
  },
  {
    "controlkey": "pt23_LingualClinicalAttachmentLevelC",
    "controlvalue": 509
  },
  {
    "controlkey": "pt23_LingualClinicalAttachmentLevelD",
    "controlvalue": 510
  },
  {
    "controlkey": "pt22_LingualClinicalAttachmentLevelM",
    "controlvalue": 511
  },
  {
    "controlkey": "pt22_LingualClinicalAttachmentLevelC",
    "controlvalue": 512
  },
  {
    "controlkey": "pt22_LingualClinicalAttachmentLevelD",
    "controlvalue": 513
  },
  {
    "controlkey": "pt21_LingualClinicalAttachmentLevelM",
    "controlvalue": 514
  },
  {
    "controlkey": "pt21_LingualClinicalAttachmentLevelC",
    "controlvalue": 515
  },
  {
    "controlkey": "pt21_LingualClinicalAttachmentLevelD",
    "controlvalue": 516
  },
  {
    "controlkey": "pt20_LingualClinicalAttachmentLevelM",
    "controlvalue": 517
  },
  {
    "controlkey": "pt20_LingualClinicalAttachmentLevelC",
    "controlvalue": 518
  },
  {
    "controlkey": "pt20_LingualClinicalAttachmentLevelD",
    "controlvalue": 519
  },
  {
    "controlkey": "pt19_LingualClinicalAttachmentLevelM",
    "controlvalue": 520
  },
  {
    "controlkey": "pt19_LingualClinicalAttachmentLevelC",
    "controlvalue": 521
  },
  {
    "controlkey": "pt19_LingualClinicalAttachmentLevelD",
    "controlvalue": 522
  },
  {
    "controlkey": "pt18_LingualClinicalAttachmentLevelM",
    "controlvalue": 523
  },
  {
    "controlkey": "pt18_LingualClinicalAttachmentLevelC",
    "controlvalue": 524
  },
  {
    "controlkey": "pt18_LingualClinicalAttachmentLevelD",
    "controlvalue": 525
  },
  {
    "controlkey": "pt17_LingualClinicalAttachmentLevelM",
    "controlvalue": 526
  },
  {
    "controlkey": "pt17_LingualClinicalAttachmentLevelC",
    "controlvalue": 527
  },
  {
    "controlkey": "pt17_LingualClinicalAttachmentLevelD",
    "controlvalue": 528
  },
  {
    "controlkey": "pt17_FacialClinicalAttachmentLevelM",
    "controlvalue": 529
  },
  {
    "controlkey": "pt17_FacialClinicalAttachmentLevelC",
    "controlvalue": 530
  },
  {
    "controlkey": "pt17_FacialClinicalAttachmentLevelD",
    "controlvalue": 531
  },
  {
    "controlkey": "pt18_FacialClinicalAttachmentLevelM",
    "controlvalue": 532
  },
  {
    "controlkey": "pt18_FacialClinicalAttachmentLevelC",
    "controlvalue": 533
  },
  {
    "controlkey": "pt18_FacialClinicalAttachmentLevelD",
    "controlvalue": 534
  },
  {
    "controlkey": "pt19_FacialClinicalAttachmentLevelM",
    "controlvalue": 535
  },
  {
    "controlkey": "pt19_FacialClinicalAttachmentLevelC",
    "controlvalue": 536
  },
  {
    "controlkey": "pt19_FacialClinicalAttachmentLevelD",
    "controlvalue": 537
  },
  {
    "controlkey": "pt20_FacialClinicalAttachmentLevelM",
    "controlvalue": 538
  },
  {
    "controlkey": "pt20_FacialClinicalAttachmentLevelC",
    "controlvalue": 539
  },
  {
    "controlkey": "pt20_FacialClinicalAttachmentLevelD",
    "controlvalue": 540
  },
  {
    "controlkey": "pt21_FacialClinicalAttachmentLevelM",
    "controlvalue": 541
  },
  {
    "controlkey": "pt21_FacialClinicalAttachmentLevelC",
    "controlvalue": 542
  },
  {
    "controlkey": "pt21_FacialClinicalAttachmentLevelD",
    "controlvalue": 543
  },
  {
    "controlkey": "pt22_FacialClinicalAttachmentLevelM",
    "controlvalue": 544
  },
  {
    "controlkey": "pt22_FacialClinicalAttachmentLevelC",
    "controlvalue": 545
  },
  {
    "controlkey": "pt22_FacialClinicalAttachmentLevelD",
    "controlvalue": 546
  },
  {
    "controlkey": "pt23_FacialClinicalAttachmentLevelM",
    "controlvalue": 547
  },
  {
    "controlkey": "pt23_FacialClinicalAttachmentLevelC",
    "controlvalue": 548
  },
  {
    "controlkey": "pt23_FacialClinicalAttachmentLevelD",
    "controlvalue": 549
  },
  {
    "controlkey": "pt24_FacialClinicalAttachmentLevelM",
    "controlvalue": 550
  },
  {
    "controlkey": "pt24_FacialClinicalAttachmentLevelC",
    "controlvalue": 551
  },
  {
    "controlkey": "pt24_FacialClinicalAttachmentLevelD",
    "controlvalue": 552
  },
  {
    "controlkey": "pt25_FacialClinicalAttachmentLevelD",
    "controlvalue": 553
  },
  {
    "controlkey": "pt25_FacialClinicalAttachmentLevelC",
    "controlvalue": 554
  },
  {
    "controlkey": "pt25_FacialClinicalAttachmentLevelM",
    "controlvalue": 555
  },
  {
    "controlkey": "pt26_FacialClinicalAttachmentLevelD",
    "controlvalue": 556
  },
  {
    "controlkey": "pt26_FacialClinicalAttachmentLevelC",
    "controlvalue": 557
  },
  {
    "controlkey": "pt26_FacialClinicalAttachmentLevelM",
    "controlvalue": 558
  },
  {
    "controlkey": "pt27_FacialClinicalAttachmentLevelD",
    "controlvalue": 559
  },
  {
    "controlkey": "pt27_FacialClinicalAttachmentLevelC",
    "controlvalue": 560
  },
  {
    "controlkey": "pt27_FacialClinicalAttachmentLevelM",
    "controlvalue": 561
  },
  {
    "controlkey": "pt28_FacialClinicalAttachmentLevelD",
    "controlvalue": 562
  },
  {
    "controlkey": "pt28_FacialClinicalAttachmentLevelC",
    "controlvalue": 563
  },
  {
    "controlkey": "pt28_FacialClinicalAttachmentLevelM",
    "controlvalue": 564
  },
  {
    "controlkey": "pt29_FacialClinicalAttachmentLevelD",
    "controlvalue": 565
  },
  {
    "controlkey": "pt29_FacialClinicalAttachmentLevelC",
    "controlvalue": 566
  },
  {
    "controlkey": "pt29_FacialClinicalAttachmentLevelM",
    "controlvalue": 567
  },
  {
    "controlkey": "pt30_FacialClinicalAttachmentLevelD",
    "controlvalue": 568
  },
  {
    "controlkey": "pt30_FacialClinicalAttachmentLevelC",
    "controlvalue": 569
  },
  {
    "controlkey": "pt30_FacialClinicalAttachmentLevelM",
    "controlvalue": 570
  },
  {
    "controlkey": "pt31_FacialClinicalAttachmentLevelD",
    "controlvalue": 571
  },
  {
    "controlkey": "pt31_FacialClinicalAttachmentLevelC",
    "controlvalue": 572
  },
  {
    "controlkey": "pt31_FacialClinicalAttachmentLevelM",
    "controlvalue": 573
  },
  {
    "controlkey": "pt32_FacialClinicalAttachmentLevelD",
    "controlvalue": 574
  },
  {
    "controlkey": "pt32_FacialClinicalAttachmentLevelC",
    "controlvalue": 575
  },
  {
    "controlkey": "pt32_FacialClinicalAttachmentLevelM",
    "controlvalue": 576
  }
]
